import { Link } from 'react-router-dom'
import checkIcon from '../../images/check_icon.jpeg'

function DirectDebitSuccessPage() {
  return (
    <div className='min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4'>
      <div className='max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center'>
        {/* Success Message */}
        <h1 className='text-2xl font-bold text-gray-900 mb-3'>
          Direct Debit Consent Granted Successfully!
        </h1>

        <p className='text-gray-600 mb-8'>
          Thank you for granting consent. Your Direct Debit verification process has been completed
          successfully.
        </p>

        {/* Illustration */}
        <div className='my-16'>
          <img
            src={checkIcon}
            alt='Success Illustration'
            className='w-20 h-20 mx-auto object-contain'
          />
        </div>

        {/* Action Button */}
        <Link
          to='/'
          className='inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200'
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  )
}

export default DirectDebitSuccessPage
